import TestingLoading from './TestingLoading';

export default TestingLoading;
